function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode2Fone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "781px",
    height: "780px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#63AAAB",
    d: "M 372.5,-0.5 C 387.833,-0.5 403.167,-0.5 418.5,-0.5C 539.818,10.8922 636.651,65.2255 709,162.5C 749.742,220.89 773.576,285.556 780.5,356.5C 780.5,378.5 780.5,400.5 780.5,422.5C 766.247,548.561 706.914,647.061 602.5,718C 546.202,753.599 484.869,774.099 418.5,779.5C 400.167,779.5 381.833,779.5 363.5,779.5C 230.924,766.316 128.757,703.983 57,592.5C 17.3664,526.299 -1.13357,454.633 1.5,377.5C 6.11336,357.445 16.4467,340.945 32.5,328C 44.6178,318.552 57.2845,309.885 70.5,302C 105.483,284.176 140.15,265.843 174.5,247C 200.151,231.683 219.985,210.849 234,184.5C 238.667,175.167 243.333,165.833 248,156.5C 259.333,127.833 270.667,99.1667 282,70.5C 289.992,52.6705 300.825,36.8371 314.5,23C 331.52,9.3839 350.854,1.55056 372.5,-0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode2Fone);
export default __webpack_public_path__ + "static/media/code_2_fone.524750e71b2bc1d2fd8d1df41c8ec090.svg";
export { ForwardRef as ReactComponent };